import { OpcaoGenerica } from './opcao-generica';
import { PerguntaVinculada } from './pergunta-vinculada';


export class Question{
    public key:number;
    public text:string;
    public required:boolean;
    public multiple:boolean;
    public disable: boolean;
    public order:number;
    public limitMax:number;
    public limitMin:number;
    public tooltip:string;
    public alerta:string;
    public controlType:string;
    public idCategoria: number;
    public options: OpcaoGenerica[];
    public perguntaVinculada:PerguntaVinculada;
    public mostrarSalvarConcluir: boolean;
    public style: Object;

}
